module.exports = __webpack_public_path__ + "img/blueChain.63d5bc05.svg";